'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var paths = require('./paths.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Svg = styled.svg.withConfig({
  componentId: "o86w7e-0"
})(function (_ref) {
  var s = _ref.s;
  return _objectSpread({
    width: '4rem',
    height: 'auto',
    fill: s && s.color || '#000',
    verticalAlign: 'middle'
  }, s);
});
var PrinterlessIcon = function PrinterlessIcon(_ref2) {
  var s = _ref2.s,
    fillColor = _ref2.fillColor,
    lineColor = _ref2.lineColor,
    backgroundColor = _ref2.backgroundColor;
  return /*#__PURE__*/React.createElement(Svg, {
    s: s,
    viewBox: "0 0 80 80",
    role: "img"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: paths.background,
    fill: backgroundColor
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.mobileOutline,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 51.478261)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: fillColor,
    cx: "3.64",
    cy: "4.17391304",
    rx: "2.38",
    ry: "2.36521739"
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.homeButtonEllipse,
    fill: lineColor
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.200000, 19.478261)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: fillColor,
    x: "1.68",
    y: "0.973913043",
    width: "8.26",
    height: "8.20869565"
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.topLeftSquare,
    fill: lineColor
  })), /*#__PURE__*/React.createElement("path", {
    d: paths.topLeftDot,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.200000, 34.782609)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: fillColor,
    x: "1.68",
    y: "0.834782609",
    width: "8.26",
    height: "8.20869565"
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.bottomLeftSquare,
    fill: lineColor
  })), /*#__PURE__*/React.createElement("path", {
    d: paths.bottomLeftDot,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.600000, 19.478261)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: fillColor,
    x: "1.54",
    y: "0.973913043",
    width: "8.26",
    height: "8.20869565"
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.topRightSquare,
    fill: lineColor
  })), /*#__PURE__*/React.createElement("path", {
    d: paths.topRightDot,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.centerLeftAngleBracket,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.topCenterLine,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.topBottomLine,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.bottomRightSquareBracket,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.bottomRightRightBracket,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.topHorizontalLine,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.bottomRightLeftBracket,
    fill: lineColor
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.600000, 30.608696)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: fillColor,
    x: "1.54",
    y: "1.53043478",
    width: "3.5",
    height: "3.47826087"
  }), /*#__PURE__*/React.createElement("path", {
    d: paths.bottomRightCircleDot,
    fill: lineColor
  })), /*#__PURE__*/React.createElement("path", {
    d: paths.bottomRightTopRightBracket,
    fill: lineColor
  })));
};
PrinterlessIcon.defaultProps = {
  fillColor: '#CCCBCB',
  lineColor: '#231F20',
  backgroundColor: '#FFFFFF',
  s: {}
};
PrinterlessIcon.propTypes = {
  fillColor: PropTypes.string,
  lineColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
    color: PropTypes.string,
    verticalAlign: PropTypes.string
  })
};

exports.default = PrinterlessIcon;
